export const formatOrderDate = (
    dateString: string | null,
    localeCode: string | undefined,
): string => {
    if (!dateString) {
        return "-";
    }

    const date = new Date(dateString);

    if (Number.isNaN(date.getTime())) {
        return "-";
    }

    const locale = localeCode?.replace("_", "-") ?? "en-GB";

    return new Intl.DateTimeFormat(locale, {
        day: "numeric",
        month: "long",
        year: "numeric",
    }).format(date);
};
